import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { FireflyCollapsedPopoverComponent } from '../../../chips/editable-chip-group/collapsed-popover/collapsed-popover.component';
import { FireflyListModule } from '../../../lists/list.module';
import { FireflyFormattingModule } from '../../../utils/formatting/formatting.module';

/**
 * `f-location-collapsed-popover`
 *
 * Extends `f-collapsed-popover` with support for a `customPopoverTpl` that is
 * read from the modal/popover `context` object (set by `f-location-editable-chip-group`).
 *
 * When `customPopoverTpl` is set, it renders the template instead of the default
 * concised-item list. This is used by the location suggester to show the
 * name + include/exclude label for each selected location.
 */
@Component({
  selector: 'f-location-collapsed-popover',
  standalone: true,
  imports: [CommonModule, FireflyListModule, FireflyFormattingModule],
  templateUrl: './location-collapsed-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireflyLocationCollapsedPopoverComponent extends FireflyCollapsedPopoverComponent {
  /**
   * Reads the optional `customPopoverTpl` from the modal context.
   * `f-location-editable-chip-group` passes itself as `context`, and it has
   * a `customPopoverTpl` @Input that the host (f-location-chip-group) binds.
   */
  get customPopoverTplRef(): TemplateRef<unknown> | null {
    return (this.context as { customPopoverTpl?: TemplateRef<unknown> | null })?.customPopoverTpl ?? null;
  }
}
